import { container } from "assets/jss/material-kit-react.jsx";

const footerStyle = {
  block: {
    color: "black",
    padding: "0.9375rem",
    fontWeight: "500",
    fontSize: "16px",
    textTransform: "uppercase",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "block",
    "&,&:hover,&:focus": {
      color: "#000"
     },
 },
  left: {
    float: "left!important",
    display: "block"
  },
  right: {
    padding: "15px 0",
    margin: "0",
    float: "right!important"
  },
  footer: {
    padding: "0.9375rem 0",
    textAlign: "center",
    display: "flex",
    zIndex: "2",
    position: "relative"
  },
   description: {
    color: "#000",
    textAlign: "justify",
    textJustify: "auto",
  },
  descr: {
    color: "#000",
    textAlign: "center",  
  },

  a: {
    color: 'black',
    textDecoration: "none",
    backgroundColor: "transparent",
      "&,&:hover,&:focus": {
      color: "#00FF00"
    }
  },
  footerWhiteFont: {
    "&,&:hover,&:focus": {
      color: "#FFFFFF"
    }
  },
  container,
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0"
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0px",
    width: "auto"
  },
  icon: {
    width: "18px",
    height: "18px",
    position: "relative",
    top: "3px"
  }
};
export default footerStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/components/footerStyle.jsx